import React, { useState, useEffect } from "react"
import ShopActions from "redux-store/models/shop"
import AuthActions from "redux-store/models/auth"
import { Loader } from "shared-components"
import "./style.css"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { get } from "lodash"
import { Radio, Modal } from "antd"
import { Form } from 'antd';

import images from "themes/images"

export let removeComma = (str) => {
  if (str) {
    return Number(str.replace(/,/g, "."))
  } else return str
}

const FORM_DATA = {
  name: "",
  last_name: "",
  paese: "Italia",
  via_nr: "",
  email: "",
  tel: "",
  citty: "",
  cap: "",
  // indirizzo_diff: true,
  // punto_vendia: false,
  // payment: 1,
  // paymentBtnLabel: "BPoint Wallet",
  terms: false,
  carrier: "",
  comment: "",
  isClicked: false,
  carrier_cost: 0,
}

const InpCheck = ({ id, label1, label2, handler, checked }) => (
  <>
    <input id={id} type="checkbox" checked={checked} onChange={handler} />
    <label htmlFor={id}>
      <div>
        <i className="fal fa-check" aria-hidden="true"></i>
      </div>
      {label2 ? (
        <span>
          {label1} <span>{label2}</span>{" "}
        </span>
      ) : (
        label1
      )}
    </label>
  </>
)

const CheckOutDom = ({
  checkOut,
  // match,
  accountInfo,
  itemsCart,
  getCarries,
  carriers,
  form,
  hasLoader,
  orderD,
  setOrderDetails,
  cap,
  setCarries,
}) => {
  useEffect(() => {
    setData({
      ...formData,
      name: accountInfo?.profile?.name?.split?.(" ")?.[0],
      last_name: accountInfo?.profile?.name?.split?.(" ")?.[1],
      email: accountInfo?.profile?.email,
      cap: cap,
      citty: itemsCart?.user_data?.city,
      via_nr: itemsCart?.user_data?.address,
      tel: itemsCart?.user_data?.phone,
    })
    //eslint-disable-next-line
  }, [
    accountInfo,
    // match.params.id,
    // match.params.supp,
  ])
  useEffect(() => {
    if (cap !== itemsCart?.user_data.postcode) {
      setData(formData);
    }
  }, [])
  
  const [formData, setData] = useState(FORM_DATA)

  const cartprod = get(itemsCart, "cart", {})

  const [cost, setCost] = useState(0)

  const onChange = (e) => {
    setCost(e.target.cost)

    setData({
      ...formData,
      carrier: e.target.serviceName,
      carrier_cost: e.target.number_cost,
    })
  }

  let sum = 0.0

  sum = Object.keys(cartprod).reduce(function (sumT, item) {
    return (
      parseFloat(sumT) +
      parseFloat(
        removeComma(cartprod[item].Product_Price.replace(".", "")) *
          cartprod[item].quantity
      )
    ).toFixed(2)
  }, 0.0)

  let sumTot = (parseFloat(sum) + parseFloat(removeComma(cost))).toFixed(2)

  const { getFieldDecorator } = form

  const handleSubmit = (e) => {
    e.preventDefault()
    setData({ ...formData, isClicked: true })

    form.validateFields().then((values) => {
      if (formData.terms && formData.carrier.length > 0) {
        checkOut(formData, () => {
          setData(FORM_DATA)
        },accountInfo.profile.hasSepafinCredentials,accountInfo.profile.username)
      }
    })
  }

  return (
    itemsCart &&
    Object.keys(itemsCart).length > 0 && (
      <div className="shopCheckout maxWidth">
        <Modal
          title={null}
          visible={Object.keys(orderD).length > 0}
          onCancel={() => setOrderDetails({})}
          footer={null}
        >
          <div className="orderD">
            <div className="orderD__header">
              <div>
                <label>Order id:</label>
                <b>{orderD?.order_id}</b>
                <p>{orderD?.message}</p>
              </div>
            </div>
          </div>
        </Modal>

        {hasLoader && <Loader></Loader>}
        <div className="shopCheckout--form">
          <div className="shopCheckout--form__left">
            <div className="titleTop">Dettagli di fatturazione </div>

            <div className="formContainer">
              <Form onSubmit={handleSubmit}>
                <Form.Item label="Nome">
                  {getFieldDecorator("name", {
                    initialValue: formData.name,
                    rules: [
                      {
                        required: true,
                        message: "Scegli un nome",
                      },
                    ],
                  })(
                    <input
                      type="text"
                      placeholder="Nome"
                      onChange={(e) => {
                        setData({ ...formData, name: e.target.value })
                      }}
                    />
                  )}
                </Form.Item>
                <Form.Item label="Cognome">
                  {getFieldDecorator("cognome", {
                    initialValue: formData.last_name,
                    rules: [
                      {
                        required: true,
                        message: "Scegli un cognome",
                      },
                    ],
                  })(
                    <input
                      type="text"
                      placeholder="Cognome"
                      onChange={(e) => {
                        setData({ ...formData, last_name: e.target.value })
                      }}
                    />
                  )}
                </Form.Item>

                <Form.Item label="Paese">
                  {getFieldDecorator("paese", {
                    initialValue: formData.paese,
                    rules: [
                      {
                        required: true,
                        message: "Scegli un paese",
                      },
                    ],
                  })(<input type="text" readOnly placeholder="Paese/regione" />)}
                </Form.Item>
                <Form.Item label="Via">
                  {getFieldDecorator("via", {
                    initialValue: formData.via_nr,
                    rules: [
                      {
                        required: true,
                        message: "Scegli una via",
                      },
                    ],
                  })(
                    <input
                      type="text"
                      placeholder="Via e numero"
                      onChange={(e) => {
                        setData({ ...formData, via_nr: e.target.value })
                      }}
                    />
                  )}
                </Form.Item>

                <Form.Item label="Email">
                  {getFieldDecorator("email", {
                    initialValue: formData.email,
                    rules: [
                      {
                        required: true,
                        message: "Scegli una email",
                      },
                    ],
                  })(
                    <input
                      type="text"
                      placeholder="Indirizzo email"
                      onChange={(e) => {
                        setData({ ...formData, email: e.target.value })
                      }}
                    />
                  )}
                </Form.Item>
                <Form.Item label="Tel">
                  {getFieldDecorator("tel", {
                    initialValue: formData.tel,
                    rules: [
                      {
                        required: true,
                        message: "Scegli un nr telefono",
                      },
                    ],
                  })(
                    <input
                      required
                      type="text"
                      placeholder="Telefono"
                      onChange={(e) => {
                        setData({ ...formData, tel: e.target.value })
                      }}
                    />
                  )}
                </Form.Item>

                <Form.Item label="Citta">
                  {getFieldDecorator("citty", {
                    initialValue: formData.citty,
                    rules: [
                      {
                        required: true,
                        message: "Scegli una citta",
                      },
                    ],
                  })(
                    <input
                      type="text"
                      placeholder="Città"
                      onChange={(e) => {
                        setData({ ...formData, citty: e.target.value })
                      }}
                    />
                  )}
                </Form.Item>
                <Form.Item label="Cap">
                  <div className="inpGr">
                    {getFieldDecorator("cap", {
                      initialValue: formData.cap,
                      rules: [
                        {
                          required: true,
                          message: "Scegli una cap",
                        },
                        { min: 5, message: "Cap dovrebbe essere 5 characteri" },
                      ],
                    })(
                      <input
                        type="text"
                        value={cap}
                        placeholder={cap}
                        className="w-40"
                        onChange={(e) => {
                          setData({
                            ...formData,
                            cap: e.target.value,
                            carrier: "",
                          });
                          e.target.value.length === 5 &&
                            getCarries("it", e.target.value)
                          setCost(0)
                          //setData({ ...formData, carrier: "" });
                        }}
                        // onChange={(e) => {
                        //   setData({ ...formData, cap: e.target.value });
                        //   e.target.value.length === 5 &&
                        //     getCarries("it", formData.cap);
                        //   setCost(0);
                        //   setData({ ...formData, carrier: "" });
                        // }}
                      />
                    )}

                    {/* {formData.cap && formData.cap.length === 5 ? (
                      <button
                        className="w-20 recal"
                        onClick={(e) => {
                          e.preventDefault();
                          getCarries("it", formData.cap);
                          setCost(0);
                          setData({ ...formData, carrier: "" });
                        }}
                      >
                        Ricalcola spedizione
                      </button>
                    ) : (
                      <button disabled> Ricalcolaa spedizione</button>
                    )} */}
                  </div>
                </Form.Item>
                <Form.Item>
                  {getFieldDecorator("comment", {
                    initialValue: formData.comment,
                  })(
                    <input
                      type="text"
                      placeholder="Comment"
                      className="w-100"
                      onChange={(e) => {
                        setData({ ...formData, comment: e.target.value })
                      }}
                    />
                  )}
                </Form.Item>
              </Form>

              {/* <input
                type="text"
                placeholder="Nome"
                value={formData.name}
                onChange={(e) => {
                  setData({ ...formData, name: e.target.value });
                }}
              />

              <input
                type="text"
                value={formData.last_name}
                placeholder="Cognome"
                onChange={(e) => {
                  setData({ ...formData, last_name: e.target.value });
                }}
              />

              <input
                type="text"
                readOnly
                value={formData.paese}
                placeholder="Paese/regione"
              />
              <input
                required
                type="text"
                value={formData.via_nr}
                placeholder="Via e numero"
                onChange={(e) => {
                  setData({ ...formData, via_nr: e.target.value });
                }}
              />
              <input
                type="text"
                value={formData.email}
                placeholder="Indirizzo email"
                onChange={(e) => {
                  setData({ ...formData, email: e.target.value });
                }}
              />
              <input
                required
                type="text"
                value={formData.tel}
                placeholder="Telefono"
                onChange={(e) => {
                  setData({ ...formData, tel: e.target.value });
                }}
              />
              <input
                type="text"
                value={formData.citty}
                placeholder="Città"
                onChange={(e) => {
                  setData({ ...formData, citty: e.target.value });
                }}
              />

              <div className="inpGr">
                <input
                  type="text"
                  value={formData.cap}
                  placeholder="C.A.P."
                  className="w-40"
                  onChange={(e) => {
                    setData({ ...formData, cap: e.target.value });
                  }}
                />
                {formData.cap && formData.cap.length === 5 ? (
                  <button
                    className="w-20 recal"
                    onClick={() => {
                      getCarries("it", formData.cap);
                      setCost(0);
                      setData({ ...formData, carrier: "" });
                    }}
                  >
                    Ricalcola spedizione
                  </button>
                ) : (
                  <button disabled> Ricalcola spedizione</button>
                )}
              </div>
              <input
                type="text"
                value={formData.comment}
                placeholder="Comment"
                className="w-100"
                onChange={(e) => {
                  setData({ ...formData, comment: e.target.value });
                }}
              /> */}
            </div>
            {/* <div className="checkContainer">
              <InpCheck
                id="check1"
                label1="Spedire ad un indirizzo differente?"
                checked={formData.indirizzo_diff}
                handler={(e) => {
                  setData({
                    ...formData,
                    indirizzo_diff: e.target.checked,
                  });
                }}
              />
              <InpCheck
                id="check2"
                label1="Ritiro presso il punto vendita"
                checked={formData.punto_vendia}
                handler={(e) => {
                  setData({
                    ...formData,
                    punto_vendia: e.target.checked,
                  });
                }}
              />
            </div> */}
          </div>
          <div className="shopCheckout--form__right">
            <div className="titleTop">Il tuo ordine</div>
            <div className="infos">
              <div className="subTotal">
                <div>Subtotale:</div>
                <div>€ {sum && sum.replace(/\./g, ",")}</div>
              </div>
              <div className="subTotal">
                <div>Spedizione:</div>
                {cost && <div>€ {cost}</div>}
              </div>
              <div className="subTotal">
                <div>Totale:</div>
                <div>€ {sumTot && sumTot.replace(/\./g, ",")}</div>
              </div>
              {/* <div className="total">
                <div>Totale:</div>
                <div>{sumTot} €</div>
              </div> */}
              <div className="shipping">
                <div
                  className={
                    "titleTop" +
                    (formData.isClicked && formData.carrier.length === 0
                      ? " error"
                      : "")
                  }
                >
                  Scegli un tipo di Spedizione:
                </div>

                <Radio.Group onChange={onChange} serviceName={formData.carrier}>
                  {carriers &&
                    carriers.map((item, index) => {
                      return (
                        <Radio
                          // value={item.shippingService.serviceName}
                          cost={item.cost}
                          number_cost={item.number_cost}
                          key={index}
                          serviceName={item.shippingService.serviceName}
                          value={
                            item.shippingService.serviceName +
                            item.shippingService.name
                          }
                        >
                          <img
                            src={
                              images[
                                get(
                                  item.shippingService,
                                  "serviceName"
                                ).toLowerCase()
                              ]
                            }
                            alt={get(
                              item.shippingService,
                              "serviceName"
                            ).toLowerCase()}
                          ></img>

                          <div className="detailsServices">
                            <div className="radioServ">
                              {item.shippingService.transportMethod === "van" ? (
                                <i className="fas fa-truck"></i>
                              ) : (
                                <i className="fas fa-plane"></i>
                              )}{" "}
                              Consegna: <b>{item.shippingService.delay}</b>
                            </div>
                            <div className="radioServ">
                              Cost: <b>{item.cost}</b>
                            </div>
                          </div>
                        </Radio>
                      )
                    })}
                </Radio.Group>
              </div>
            </div>
            {/* <div className="titleTop">Payments:</div>
            <div className="checkContainer right">
              <InpCheck
                id="pwall"
                label1="BPoint Wallet"
                checked={formData.payment === 1}
                handler={() => {
                  setData({
                    ...formData,
                    payment: 1,
                    paymentBtnLabel: "BPoint Wallet",
                  });
                }}
              />
              <InpCheck
                id="scrill"
                label1="Skrill"
                checked={formData.payment === 2}
                handler={() => {
                  setData({
                    ...formData,
                    payment: 2,
                    paymentBtnLabel: "Skrill",
                  });
                }}
              />
              <InpCheck
                id="Satispay"
                label1="Satispay"
                checked={formData.payment === 3}
                handler={() => {
                  setData({
                    ...formData,
                    payment: 3,
                    paymentBtnLabel: "Satispay",
                  });
                }}
              />
              <InpCheck
                id="Paypal"
                label1="Paypal"
                checked={formData.payment === 4}
                handler={() => {
                  setData({
                    ...formData,
                    payment: 4,
                    paymentBtnLabel: "Paypal",
                  });
                }}
              />
            </div> */}
            <div
              className={
                "checkContainer bottom" +
                (formData.isClicked && !formData.terms ? " error" : "")
              }
            >
              <InpCheck
                id="termi"
                label1="Ho letto e accetto"
                label2="termini e condizioni*"
                checked={formData.terms}
                handler={(e) => {
                  setData({
                    ...formData,
                    terms: e.target.checked,
                  })
                }}
              />
            </div>

            <button
              className="pagaBtn"
              onClick={(e) => handleSubmit(e)}
              // onClick={() => {
              //   checkOut(formData, () => {
              //     setData(FORM_DATA);
              //   });
              // }}
            >
              Paga
              {/* PAGA CON {formData.paymentBtnLabel} */}
            </button>
          </div>
        </div>
      </div>
    )
  )
}

const mstp = (state) => ({
  carriers: state.shop.carries,
  accountInfo: state.auth.accountInfo,
  hasLoader: state.shop.hasLoader,
  orderD: state.shop.orderD,
  cap: state.shop.selectedCap,
})

export default withRouter(
  connect(mstp, { ...ShopActions, AuthActions })(Form.create()(CheckOutDom))
)
